<header class="topbar">
  <div class="topbar-inner">
    <div class="brand-area">
      <a routerLink="/" class="brand" aria-label="Alma Grower Portal home">
        <img
          class="brand-mark"
          src="images/logos/TrendsicOwl.svg"
          alt=""
          aria-hidden="true"
          width="28"
          height="44" />
        <span class="brand-title">Alma Grower Portal</span>
      </a>

      <nav class="nav-links" aria-label="Primary">
        <a
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-link">
          My Files
        </a>
        @if (showReports()) {
          <a
            routerLink="/reports"
            routerLinkActive="active"
            class="nav-link">
            Reports
          </a>
        }
        @if (showUpload()) {
          <a
            routerLink="/upload"
            routerLinkActive="active"
            class="nav-link">
            Upload
          </a>
        }
      </nav>
    </div>

    <div class="user-area">
      <div class="user-menu" [class.open]="menuOpen()">
        <button
          type="button"
          class="user-trigger"
          aria-haspopup="menu"
          [attr.aria-expanded]="menuOpen()"
          (click)="toggleMenu()">
          <span class="avatar">{{ initials() || '?' }}</span>
          @if (user(); as u) {
            <span class="user-name-inline">{{ u.name || u.email }}</span>
          }
          <svg class="chev" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
            <path
              d="M3.5 6 8 10.5 12.5 6"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>

        @if (menuOpen()) {
          <div class="user-dropdown" role="menu">
            @if (user(); as u) {
              <div class="user-card">
                <div class="user-card-avatar">{{ initials() || '?' }}</div>
                <div class="user-card-info">
                  <div class="user-card-name">{{ u.name || u.email }}</div>
                  @if (u.email && u.name && u.name !== u.email) {
                    <div class="user-card-email">{{ u.email }}</div>
                  }
                </div>
              </div>
            }
            <div class="user-dropdown-actions">
              <button
                type="button"
                class="btn btn-outline-primary w-100"
                role="menuitem"
                (click)="logout()">
                Log Out
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</header>
